import ReactGA from "react-ga4";
import { getDataFromLocalStorage } from "helpers/generalHelper";
import { GEEKS_USER } from "constants/profile";
import { NAVBAR_NAMES } from "constants/navbar";

export const ACTIONS = {
  CLICK: "click",
};

export const CATEGORIES = {
  PRICER: "How users get options in their pricer",
  FEED: "How users get options in their feed",
  AUTH: "Authentication",
  TEAM_RUN: "Team Run",
  AUDIT_TRAIL: "Audit Trail",
  VOL_SURFACE: "Vol Surface",
  MARKET_ANALYSIS: "Market Analysis",
  BUSINESS_ANALYTICS: "Business Analytics",
  NAVBAR: "Navbar",
};

export const DESCRIPTIONS = {
  ADD_OPTION: "Add option",
  ATTEMPT_LOGIN: "Attempt login",
  ATTEMPT_LOGOUT: "Attempt logout",
  PUSH_TO_TEAM_RUN: "Push to Team Run",
  DUPLICATE: "Duplicate",
};

export const CONTEXTS = {
  PRICER: "Pricer",
  ADD_OPTION: "AddOption",
  TEAM_RUN_ACTION_MENU: "TeamRunActionMenu",
  TEAM_RUN_READONLY_ACTION_MENU: "TeamRunReadonlyActionMenu",
  TEAM_RUN: "TeamRun",
  AUDIT_TRAIL_ACTION_MENU: "AuditTrailActionMenu",
  PRICER_ACTION_MENU: "PricerActionMenu",
  FEED: "Feed",
  LOGIN: "Login",
  NAVBAR: "Navbar",
  VOL_SURFACE_TOOLBAR: "VolSurfaceToolbar",
  MARKET_ANALYSIS_TOOLBAR: "MarketAnalysisToolbar",
  BUSINESS_ANALYTICS_TOOLBAR: "BusinessAnalyticsToolbar",
};

export const ELEMENTS = {
  ADD_OPTION: "AddOption",
  SUBMIT: "Submit",
  DUPLICATE: "Duplicate",
  LOGIN_SUBMIT: "LoginSubmit",
  LOGOUT: "Logout",
  PUSH_TO_TEAM_RUN: "PushToTeamRun",
};

export const EVENT_NAMES = {
  AUTH_LOGIN_ATTEMPT_BUTTON: "Auth_LoginAttempt_Button",
  AUTH_PROFILE_ICON: "Auth_Profile_Icon",
  AUTH_PROFILE_MENU: "Auth_Profile_Menu",
  AUTH_REPORT_BUG_MENU: "Auth_ReportBug_Menu",
  AUTH_LOGOUT_ATTEMPT_MENU: "Auth_LogoutAttempt_Menu",

  NAVBAR_HOME_TAB: "Navbar_Home_Tab",
  NAVBAR_TEAM_RUN_RO_TAB: "Navbar_TeamRunRO_Tab",
  NAVBAR_AUDIT_TRAIL_TAB: "Navbar_AuditTrail_Tab",
  NAVBAR_VOL_SURFACE_TAB: "Navbar_VolSurface_Tab",
  NAVBAR_MARKET_ANALYSIS_TAB: "Navbar_MarketAnalysis_Tab",
  NAVBAR_BUSINESS_ANALYTICS_TAB: "Navbar_BusinessAnalytics_Tab",
  NAVBAR_TESTING_TAB: "Navbar_Testing_Tab",
  NAVBAR_CHAT_TAB: "Navbar_Chat_Tab",
  NAVBAR_DATA_TAB: "Navbar_Data_Tab",
  NAVBAR_TRADER_TAB: "Navbar_Trader_Tab",
  NAVBAR_TAB: "Navbar_Tab",

  PRICER_COPY_SHORTHAND_MENU: "Pricer_CopyShorthand_Menu",
  PRICER_COPY_SHORTHAND_WITH_ANALYSIS_MENU:
    "Pricer_CopyShorthandWithAnalysis_Menu",
  PRICER_COPY_SHORTHAND_NO_VOLS_MENU: "Pricer_CopyShorthandNoVols_Menu",
  PRICER_COPY_SHORTHAND_NO_VOL_PREM_MENU: "Pricer_CopyShorthandNoVolPrem_Menu",
  PRICER_COPY_SHORTHAND_LEGS_MENU: "Pricer_CopyShorthandLegs_Menu",
  PRICER_DUPLICATE_MENU: "Pricer_Duplicate_Menu",
  PRICER_DELETE_MENU: "Pricer_Delete_Menu",
  PRICER_MAKE_ACTIVE_MENU: "Pricer_MakeActive_Menu",
  PRICER_MAKE_INACTIVE_MENU: "Pricer_MakeInactive_Menu",
  PRICER_OTHER_INFO_MENU: "Pricer_OtherInfo_Menu",
  PRICER_ADDITIONAL_DATA_MENU: "Pricer_AdditionalData_Menu",
  PRICER_SHOW_FORMULAS_MENU: "Pricer_ShowFormulas_Menu",
  PRICER_TRADE_MENU: "Pricer_Trade_Menu",
  PRICER_PUSH_TO_AUDIT_TRAIL_MENU: "Pricer_PushToAuditTrail_Menu",
  PRICER_PUSH_TO_TEAM_RUN_MENU: "Pricer_PushToTeamRun_Menu",
  PRICER_PAYOUT_MENU: "Pricer_Payout_Menu",
  PRICER_PAYOUT_COMPARE_MENU: "Pricer_PayoutCompare_Menu",
  PRICER_CHANGE_ROW_COLOR_MENU: "Pricer_ChangeRowColor_Menu",
  PRICER_COPY_SHORTHAND_ICON: "Pricer_CopyShorthand_Icon",
  PRICER_PUSH_TO_TEAM_RUN_ICON: "Pricer_PushToTeamRun_Icon",
  PRICER_CALCULATION_DATE_CHANGE: "Pricer_CalculationDate_Change",
  PRICER_RESET_SORT_BUTTON: "Pricer_ResetSort_Button",
  PRICER_COLLAPSE_ALL_BUTTON: "Pricer_CollapseAll_Button",
  PRICER_COMMODITY_FILTER_BUTTON: "Pricer_CommodityFilter_Button",
  PRICER_CSV_IMPORT_OPEN: "Pricer_CsvImport_Open",
  PRICER_CSV_IMPORT_SUCCESS: "Pricer_CsvImport_Success",
  PRICER_IMPORT_TRADES_OPEN: "Pricer_ImportTrades_Open",
  PRICER_IMPORT_TRADES_UPLOAD_SUCCESS: "Pricer_ImportTrades_UploadSuccess",
  PRICER_IMPORT_TRADES_VALIDATE_SUCCESS: "Pricer_ImportTrades_ValidateSuccess",
  PRICER_IMPORT_TRADES_IMPORT_SUCCESS: "Pricer_ImportTrades_ImportSuccess",
  PRICER_VOL_SURFACE_COMPARISON_OPEN: "Pricer_VolSurfaceComparison_Open",
  PRICER_VOL_SURFACE_COMPARISON_PREVIEW: "Pricer_VolSurfaceComparison_Preview",
  PRICER_VOL_SURFACE_COMPARISON_SEND_SUCCESS:
    "Pricer_VolSurfaceComparison_SendSuccess",
  PRICER_ADD_OPTION_OPEN: "Pricer_AddOption_Open",
  PRICER_ADD_OPTION_SUBMIT: "Pricer_AddOption_Submit",
  PRICER_QUICK_ADD_OPEN: "Pricer_QuickAdd_Open",
  PRICER_QUICK_ADD_ADD: "Pricer_QuickAdd_Add",
  PRICER_QUICK_ADD_SUCCESS: "Pricer_QuickAdd_Success",

  TEAM_RUN_COPY_SHORTHAND_ICON: "TeamRun_CopyShorthand_Icon",
  TEAM_RUN_PULL_TO_PRICER_ICON: "TeamRun_PullToPricer_Icon",
  TEAM_RUN_UPDATE_BID_ASK_ICON: "TeamRun_UpdateBidAsk_Icon",
  TEAM_RUN_COPY_SHORTHAND_MENU: "TeamRun_CopyShorthand_Menu",
  TEAM_RUN_COPY_SHORTHAND_DELTA_MENU: "TeamRun_CopyShorthandWithDelta_Menu",
  TEAM_RUN_COPY_SHORTHAND_NO_VOLS_MENU: "TeamRun_CopyShorthandNoVols_Menu",
  TEAM_RUN_COPY_SHORTHAND_NO_VOL_PREM_MENU:
    "TeamRun_CopyShorthandNoVolPrem_Menu",
  TEAM_RUN_PULL_TO_PRICER_MENU: "TeamRun_PullToPricer_Menu",
  TEAM_RUN_UPDATE_BID_ASK_MENU: "TeamRun_UpdateBidAsk_Menu",
  TEAM_RUN_DUPLICATE_AND_MAKE_LIVE_MENU: "TeamRun_DuplicateAndMakeLive_Menu",
  TEAM_RUN_DUPLICATE_AND_REMOVE_LIVE_MENU:
    "TeamRun_DuplicateAndRemoveLive_Menu",
  TEAM_RUN_ARCHIVE_MENU: "TeamRun_Archive_Menu",
  TEAM_RUN_DETAILED_AUDIT_TRAIL_MENU: "TeamRun_DetailedAuditTrail_Menu",
  TEAM_RUN_ADDITIONAL_DATA_MENU: "TeamRun_AdditionalData_Menu",
  TEAM_RUN_TRADE_MENU: "TeamRun_Trade_Menu",
  TEAM_RUN_PAYOUT_MENU: "TeamRun_Payout_Menu",
  TEAM_RUN_BLAST_MENU: "TeamRun_Blast_Menu",
  TEAM_RUN_HIGHLIGHT_MENU: "TeamRun_Highlight_Menu",
  TEAM_RUN_UNHIGHLIGHT_MENU: "TeamRun_Unhighlight_Menu",
  TEAM_RUN_MAKE_ACTIVE_MENU: "TeamRun_MakeActive_Menu",
  TEAM_RUN_MAKE_INACTIVE_MENU: "TeamRun_MakeInactive_Menu",
  TEAM_RUN_CHANGE_ROW_COLOR_MENU: "TeamRun_ChangeRowColor_Menu",

  TEAM_RUN_READONLY_COPY_SHORTHAND_MENU: "TeamRunReadonly_CopyShorthand_Menu",
  TEAM_RUN_READONLY_COPY_SHORTHAND_NO_VOLS_MENU:
    "TeamRunReadonly_CopyShorthandNoVols_Menu",
  TEAM_RUN_READONLY_DETAILED_AUDIT_TRAIL_MENU:
    "TeamRunReadonly_DetailedAuditTrail_Menu",
  TEAM_RUN_READONLY_ADDITIONAL_DATA_MENU: "TeamRunReadonly_AdditionalData_Menu",

  TRADER_PULL_TO_PRICER_MENU: "Trader_PullToPricer_Menu",
  TRADER_PULL_TO_PRICER_ICON: "Trader_PullToPricer_Icon",

  FEED_COPY_SHORTHAND_ICON: "Feed_CopyShorthand_Icon",
  FEED_COPY_SHORTHAND_CONTEXT_MENU: "Feed_CopyShorthand_ContextMenu",
  FEED_PULL_TO_PRICER_ICON: "Feed_PullToPricer_Icon",
  FEED_PULL_TO_PRICER_CONTEXT_MENU: "Feed_PullToPricer_ContextMenu",
  FEED_DETAILED_AUDIT_TRAIL_ICON: "Feed_DetailedAuditTrail_Icon",
  FEED_DETAILED_AUDIT_TRAIL_CONTEXT_MENU: "Feed_DetailedAuditTrail_ContextMenu",
  FEED_COPY_EOD_EMAIL_BODY_ICON: "Feed_CopyEodEmailBody_Icon",
  FEED_COPY_EOD_EMAIL_BODY_CONTEXT_MENU: "Feed_CopyEodEmailBody_ContextMenu",

  AUDIT_TRAIL_COPY_SHORTHAND_MENU: "AuditTrail_CopyShorthand_Menu",
  AUDIT_TRAIL_COPY_SHORTHAND_NO_VOLS_MENU: "AuditTrail_CopyShorthandNoVols_Menu",
  AUDIT_TRAIL_COPY_SHORTHAND_LEGS_MENU: "AuditTrail_CopyShorthandLegs_Menu",
  AUDIT_TRAIL_PULL_TO_PRICER_MENU: "AuditTrail_PullToPricer_Menu",
  AUDIT_TRAIL_TRADE_MENU: "AuditTrail_Trade_Menu",
  AUDIT_TRAIL_ADDITIONAL_DATA_MENU: "AuditTrail_AdditionalData_Menu",
  AUDIT_TRAIL_DETAILED_AUDIT_TRAIL_MENU: "AuditTrail_DetailedAuditTrail_Menu",
  AUDIT_TRAIL_COPY_TRADE_DETAILS_MENU: "AuditTrail_CopyTradeDetails_Menu",
  AUDIT_TRAIL_EDIT_TRADE_DETAILS_MENU: "AuditTrail_EditTradeDetails_Menu",
  AUDIT_TRAIL_VOID_OPEN_MENU: "AuditTrail_VoidOpen_Menu",
  AUDIT_TRAIL_CLEARING_MODAL_OPEN_MENU: "AuditTrail_ClearingModalOpen_Menu",
  AUDIT_TRAIL_CLEARING_LINK_MENU: "AuditTrail_ClearingLink_Menu",
  AUDIT_TRAIL_CLEARING_UNLINK_MENU: "AuditTrail_ClearingUnlink_Menu",
  AUDIT_TRAIL_CLEARING_GROUP_MENU: "AuditTrail_ClearingGroup_Menu",
  AUDIT_TRAIL_CLEARING_UNGROUP_MENU: "AuditTrail_ClearingUngroup_Menu",
  AUDIT_TRAIL_FILTER_MATCHES_MENU: "AuditTrail_FilterMatches_Menu",
  AUDIT_TRAIL_COPY_SHORTHAND_CONTEXT_MENU: "AuditTrail_CopyShorthand_ContextMenu",
  AUDIT_TRAIL_COPY_NO_VOLS_CONTEXT_MENU: "AuditTrail_CopyNoVols_ContextMenu",
  AUDIT_TRAIL_COPY_SHORTHAND_LEGS_CONTEXT_MENU:
    "AuditTrail_CopyShorthandLegs_ContextMenu",
  AUDIT_TRAIL_PULL_TO_PRICER_CONTEXT_MENU: "AuditTrail_PullToPricer_ContextMenu",
  AUDIT_TRAIL_TRADE_CONTEXT_MENU: "AuditTrail_Trade_ContextMenu",
  AUDIT_TRAIL_ADDITIONAL_DATA_CONTEXT_MENU: "AuditTrail_AdditionalData_ContextMenu",
  AUDIT_TRAIL_DETAILED_AUDIT_TRAIL_CONTEXT_MENU:
    "AuditTrail_DetailedAuditTrail_ContextMenu",
  AUDIT_TRAIL_COPY_TRADE_DETAILS_CONTEXT_MENU:
    "AuditTrail_CopyTradeDetails_ContextMenu",
  AUDIT_TRAIL_EDIT_TRADE_DETAILS_CONTEXT_MENU:
    "AuditTrail_EditTradeDetails_ContextMenu",
  AUDIT_TRAIL_VOID_OPEN_CONTEXT_MENU: "AuditTrail_VoidOpen_ContextMenu",
  AUDIT_TRAIL_FILTER_MATCHES_CONTEXT_MENU: "AuditTrail_FilterMatches_ContextMenu",
  AUDIT_TRAIL_COPY_SHORTHAND_ICON: "AuditTrail_CopyShorthand_Icon",
  AUDIT_TRAIL_PULL_TO_PRICER_ICON: "AuditTrail_PullToPricer_Icon",
  AUDIT_TRAIL_COPY_TRADE_DETAILS_ICON: "AuditTrail_CopyTradeDetails_Icon",
  AUDIT_TRAIL_VOID_CONFIRM: "AuditTrail_Void_Confirm",

  VOL_SURFACE_GRAPH_OR_TABLE_TAB: "VolSurface_GraphOrTable_Tab",
  VOL_SURFACE_STICKY_MODE_TAB: "VolSurface_StickyMode_Tab",
  VOL_SURFACE_SHORTCUT_FILTER: "VolSurface_ShortcutFilter",
  VOL_SURFACE_FILTER_CHANGE: "VolSurface_FilterChange",
  VOL_SURFACE_COMPARISON_OPEN: "VolSurface_Comparison_Open",
  VOL_SURFACE_COMPARISON_PREVIEW: "VolSurface_Comparison_Preview",
  VOL_SURFACE_COMPARISON_SEND_SUCCESS: "VolSurface_Comparison_SendSuccess",

  MARKET_ANALYSIS_GRAPH_OR_TABLE_TAB: "MarketAnalysis_GraphOrTable_Tab",
  MARKET_ANALYSIS_STICKY_MODE_TAB: "MarketAnalysis_StickyMode_Tab",
  MARKET_ANALYSIS_SHORTCUT_FILTER: "MarketAnalysis_ShortcutFilter",
  MARKET_ANALYSIS_FILTER_CHANGE: "MarketAnalysis_FilterChange",
  MARKET_ANALYSIS_MAIN_TAB: "MarketAnalysis_MainTab",
  MARKET_ANALYSIS_TIME_SERIES_SHORTCUT: "MarketAnalysis_TimeSeriesShortcut",
  MARKET_ANALYSIS_DAILY_REPORT_SHORTCUT: "MarketAnalysis_DailyReportShortcut",
  MARKET_ANALYSIS_DAILY_REPORT_DATE_RANGE: "MarketAnalysis_DailyReportDateRange",
  MARKET_ANALYSIS_TABLE_EXPORT_REQUEST: "MarketAnalysis_TableExportRequest",
  MARKET_ANALYSIS_EXPORT_FILE_DOWNLOAD: "MarketAnalysis_ExportFileDownload",
  MARKET_ANALYSIS_EXPORTS_MODAL_OPEN: "MarketAnalysis_ExportsModalOpen",

  BUSINESS_ANALYTICS_MAIN_TAB: "BusinessAnalytics_MainTab",
  BUSINESS_ANALYTICS_SCREEN: "BusinessAnalytics_Screen",
};

export const COMPONENT_NAMES = {
  BUTTON: "Button",
  MENU_BUTTON: "MenuButton",
  ICON_BUTTON: "IconButton",
  FEED_ICON_BUTTON: "FeedIconButton",
};

const VOL_SURFACE_TOOLBAR_EVENTS = {
  graph_or_table: EVENT_NAMES.VOL_SURFACE_GRAPH_OR_TABLE_TAB,
  sticky_mode: EVENT_NAMES.VOL_SURFACE_STICKY_MODE_TAB,
  shortcut_filter: EVENT_NAMES.VOL_SURFACE_SHORTCUT_FILTER,
  filter_change: EVENT_NAMES.VOL_SURFACE_FILTER_CHANGE,
};

const MARKET_ANALYSIS_TOOLBAR_EVENTS = {
  graph_or_table: EVENT_NAMES.MARKET_ANALYSIS_GRAPH_OR_TABLE_TAB,
  sticky_mode: EVENT_NAMES.MARKET_ANALYSIS_STICKY_MODE_TAB,
  shortcut_filter: EVENT_NAMES.MARKET_ANALYSIS_SHORTCUT_FILTER,
  filter_change: EVENT_NAMES.MARKET_ANALYSIS_FILTER_CHANGE,
  main_tab: EVENT_NAMES.MARKET_ANALYSIS_MAIN_TAB,
  time_series_shortcut: EVENT_NAMES.MARKET_ANALYSIS_TIME_SERIES_SHORTCUT,
  daily_report_shortcut: EVENT_NAMES.MARKET_ANALYSIS_DAILY_REPORT_SHORTCUT,
  daily_report_date_range: EVENT_NAMES.MARKET_ANALYSIS_DAILY_REPORT_DATE_RANGE,
  table_export_request: EVENT_NAMES.MARKET_ANALYSIS_TABLE_EXPORT_REQUEST,
  export_file_download: EVENT_NAMES.MARKET_ANALYSIS_EXPORT_FILE_DOWNLOAD,
  exports_modal_open: EVENT_NAMES.MARKET_ANALYSIS_EXPORTS_MODAL_OPEN,
};

const BUSINESS_ANALYTICS_TOOLBAR_EVENTS = {
  main_tab: EVENT_NAMES.BUSINESS_ANALYTICS_MAIN_TAB,
  screen: EVENT_NAMES.BUSINESS_ANALYTICS_SCREEN,
};

const NAVBAR_TAB_EVENTS = {
  [NAVBAR_NAMES.HOME]: EVENT_NAMES.NAVBAR_HOME_TAB,
  [NAVBAR_NAMES.TEAM_RUN_READONLY]: EVENT_NAMES.NAVBAR_TEAM_RUN_RO_TAB,
  [NAVBAR_NAMES.AUDIT_TRAIL]: EVENT_NAMES.NAVBAR_AUDIT_TRAIL_TAB,
  [NAVBAR_NAMES.VOL_SURFACE]: EVENT_NAMES.NAVBAR_VOL_SURFACE_TAB,
  [NAVBAR_NAMES.MARKET_ANALYSIS]: EVENT_NAMES.NAVBAR_MARKET_ANALYSIS_TAB,
  [NAVBAR_NAMES.BUSINESS_ANALYTICS]: EVENT_NAMES.NAVBAR_BUSINESS_ANALYTICS_TAB,
  [NAVBAR_NAMES.TESTING]: EVENT_NAMES.NAVBAR_TESTING_TAB,
  [NAVBAR_NAMES.CHAT]: EVENT_NAMES.NAVBAR_CHAT_TAB,
  [NAVBAR_NAMES.VOL_SURFACE_DATA]: EVENT_NAMES.NAVBAR_DATA_TAB,
  [NAVBAR_NAMES.TRADER]: EVENT_NAMES.NAVBAR_TRADER_TAB,
};

let sendEventSeq = 0;

export const sendEvent = ({
  category,
  action,
  description,
  eventName,
  context,
  element,
  component,
  extraParams,
}) => {
  const params = {};
  if (process.env.REACT_APP_NODE_ENV) {
    params.app_environment = process.env.REACT_APP_NODE_ENV;
  }
  if (category) params.category = category;
  if (action) params.action = action;
  if (description) params.description = description;
  if (eventName) params.eventName = eventName;
  if (context) params.context = context;
  if (element) params.element = element;
  if (component) params.component = component;
  const user = getDataFromLocalStorage(GEEKS_USER);
  const userId = user?.user_id ?? user?.id ?? null;
  if (userId != null) params.user_id = userId;
  if (extraParams && typeof extraParams === "object") {
    Object.assign(params, extraParams);
  }

  // GA4 drops identical name+params in the same second. Unique seq keeps repeat clicks countable.
  params.event_seq = `${Date.now()}_${++sendEventSeq}`;

  ReactGA.event(eventName, params);
};

const VOL_COMPARISON_EVENTS = {
  pricer: {
    open: EVENT_NAMES.PRICER_VOL_SURFACE_COMPARISON_OPEN,
    preview: EVENT_NAMES.PRICER_VOL_SURFACE_COMPARISON_PREVIEW,
    send: EVENT_NAMES.PRICER_VOL_SURFACE_COMPARISON_SEND_SUCCESS,
  },
  vol_surface: {
    open: EVENT_NAMES.VOL_SURFACE_COMPARISON_OPEN,
    preview: EVENT_NAMES.VOL_SURFACE_COMPARISON_PREVIEW,
    send: EVENT_NAMES.VOL_SURFACE_COMPARISON_SEND_SUCCESS,
  },
};

export function trackVolSurfaceComparison(
  step,
  { fromPricer = false, extraParams } = {}
) {
  const eventName =
    VOL_COMPARISON_EVENTS[fromPricer ? "pricer" : "vol_surface"][step];
  if (!eventName) return;

  sendEvent({
    category: fromPricer ? CATEGORIES.PRICER : CATEGORIES.VOL_SURFACE,
    context: fromPricer ? CONTEXTS.PRICER : CONTEXTS.VOL_SURFACE_TOOLBAR,
    action: ACTIONS.CLICK,
    component: COMPONENT_NAMES.BUTTON,
    eventName,
    extraParams,
  });
}

export function trackVolSurfaceToolbar(control, extraParams = {}) {
  const eventName = VOL_SURFACE_TOOLBAR_EVENTS[control];
  if (!eventName) return;

  sendEvent({
    category: CATEGORIES.VOL_SURFACE,
    context: CONTEXTS.VOL_SURFACE_TOOLBAR,
    action: ACTIONS.CLICK,
    eventName,
    extraParams,
  });
}

export function trackMarketAnalysisToolbar(control, extraParams = {}) {
  const eventName = MARKET_ANALYSIS_TOOLBAR_EVENTS[control];
  if (!eventName) return;

  sendEvent({
    category: CATEGORIES.MARKET_ANALYSIS,
    context: CONTEXTS.MARKET_ANALYSIS_TOOLBAR,
    action: ACTIONS.CLICK,
    eventName,
    extraParams,
  });
}

export function trackBusinessAnalyticsToolbar(control, extraParams = {}) {
  const eventName = BUSINESS_ANALYTICS_TOOLBAR_EVENTS[control];
  if (!eventName) return;

  sendEvent({
    category: CATEGORIES.BUSINESS_ANALYTICS,
    context: CONTEXTS.BUSINESS_ANALYTICS_TOOLBAR,
    action: ACTIONS.CLICK,
    eventName,
    extraParams,
  });
}

export function trackNavbarTab(tabLabel) {
  const label = String(tabLabel ?? "").trim();
  if (!label || label === NAVBAR_NAMES.PROFILE) return;

  sendEvent({
    category: CATEGORIES.NAVBAR,
    context: CONTEXTS.NAVBAR,
    action: ACTIONS.CLICK,
    eventName: NAVBAR_TAB_EVENTS[label] ?? EVENT_NAMES.NAVBAR_TAB,
    extraParams: { tab: label },
  });
}
